import axios from 'axios';
import authHeader from "@/service/auth-header";

class UnpaidRunService {

    async getCompanyUnpaidRuns(companyId) {
        return await axios.get(`/api/unpaidrun/${companyId}`, {headers: authHeader()})
    }

    async createUnpaidRun(companyId, data) {
        return await axios.post(`/api/unpaidrun/${companyId}`, data, {headers: authHeader()});
    }

    async updateUnpaidRun(unpaidRunId, data) {
        return await axios.put(`/api/unpaidrun/${unpaidRunId}`, data, {headers: authHeader()});
    }

    async deleteUnpaidRun(unpaidRunId) {
        return await axios.delete(`/api/unpaidrun/${unpaidRunId}`,{ headers: authHeader() })
    }

}

export default new UnpaidRunService();
